import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class BankAccountsService {
  constructor(private http: HttpClientService) {}

  public getByHolder(holder_id, holder_type): Observable<any> {
    const options = {
      params: {
        holder_id,
        holder_type,
      },
    };
    return this.http
      .get("/api/bank_accounts/by_holder", options)
      .pipe(tap((_) => console.log("BankAccountsService.getByHolder: Ok.")));
  }

  public create(bank_account): Observable<any> {
    const params = {
      bank_account,
    };
    return this.http.post("/api/bank_accounts", params).pipe(tap((_) => console.log("BankAccountsService.create: Ok")));
  }

  public clabeInfo(clabe: string): Observable<any> {
    return this.http
      .get(`/api/bank_accounts/validate_clabe/${clabe}`)
      .pipe(tap((result: any) => console.log("BankAccountsService.clabeInfo: Ok.", result)));
  }

  public update(bank_account): Observable<any> {
    const params = {
      bank_account,
    };
    return this.http
      .put("/api/bank_accounts/" + bank_account.id, params)
      .pipe(tap((_) => console.log("BankAccountsService.update: Ok")));
  }

  public deleteAccount(bank_account_id): Observable<any> {
    return this.http
      .delete("/api/bank_accounts/" + bank_account_id)
      .pipe(tap((_) => console.log("BankAccountsService.deleteAccount: Ok")));
  }

  public updateSpecificParams({
    bank_account_id,
    clabe = undefined,
    is_for_downpayment = undefined,
    is_for_direct_debit = undefined,
  }: {
    bank_account_id: number;
    clabe?: string;
    is_for_downpayment?: boolean;
    is_for_direct_debit?: boolean;
  }): Observable<any> {
    const params: any = { clabe, is_for_downpayment, is_for_direct_debit };
    Object.keys(params).forEach((key) => params[key] === undefined && delete params[key]);

    return this.http
      .put(`/api/bank_accounts/${bank_account_id}`, params)
      .pipe(tap((_) => console.log("BankAccountsService.updateSpecificParams: Ok")));
  }

  public update_collection(bank_accounts): Observable<any> {
    const params = {
      bank_accounts,
    };
    return this.http
      .put("/api/bank_accounts/update_collection", params)
      .pipe(tap((_) => console.log("BankAccountsService.update_collection: Ok")));
  }

  public principal_bank_account(bank_account_id): Observable<any> {
    return this.http
      .put(`/api/bank_accounts/${bank_account_id}/principal_bank_account`, {})
      .pipe(tap((_) => console.log("BankAccountsService.principal_bank_account: Ok")));
  }

  public verifyBankAccount(bank_account_id): Observable<any> {
    return this.http
      .put(`/api/bank_accounts/${bank_account_id}/verify`, {})
      .pipe(tap((_) => console.log("BankAccountsService.verifyBankAccount: Ok")));
  }

  public bank_account_exists(clabe, holder_id, holder_type): Observable<any> {
    const options = {
      params: {
        clabe,
        holder_id,
        holder_type,
      },
    };
    return this.http
      .get("/api/bank_accounts/validate_clabe", options)
      .pipe(tap((_) => console.log("BankAccountsService.bank_account_exists: Ok.")));
  }

  public byClabe(clabe: string): Observable<any> {
    const options = {
      params: {
        clabe,
      },
    };
    return this.http
      .get("/api/bank_accounts/by_clabe", options)
      .pipe(tap((_) => console.log("BankAccountsService.byClabe: Ok.")));
  }

  public findByDetails(clabe, holder_id, holder_type): Observable<any> {
    const options = {
      params: {
        clabe,
        holder_id,
        holder_type,
      },
    };
    return this.http
      .get("/api/bank_accounts/find_by_details", options)
      .pipe(tap((_) => console.log("BankAccountsService.findByDetails: Ok.")));
  }
}
